const SERVICE_AREAS = {
  LOADING_PUBLIC_SERVICE_AREAS: "LOADING_PUBLIC_SERVICE_AREAS",
  GET_ALL_PUBLIC_SERVICE_AREAS: "GET_ALL_PUBLIC_SERVICE_AREAS",
  FILTER_PUBLIC_SERVICE_AREAS: "FILTER_PUBLIC_SERVICE_AREAS",
  FILTERING_PUBLIC_SERVICE_AREAS: "FILTERING_PUBLIC_SERVICE_AREAS",
};

export default SERVICE_AREAS;
